import React, { useState } from 'react';
import { Button, Card, Col, Modal, Row } from 'react-bootstrap';
import CustomCard from '../CustomCard';
import { useFetchObject } from '../hook/useFetchObject';

const GroupedPreviewList = ({
                              title,
                              api,
                              description,
                              selectedIds,
                              previewCount = 6,
                              singleGroup = false,
                            }) => {
  const { data: groups, ready } = useFetchObject(api, []);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [showModal, setShowModal] = useState(false);

  if (!ready) return null;

  const renderItems = (items, groupName = title, showGroupName = true) => (
    <div key={groupName} className="mb-4 border-top">
      {showGroupName && <h5 className="my-4">{groupName}</h5>}
      <Row className={!showGroupName ? 'mt-4' : ''}>
        {items.slice(0, previewCount).map((item, idx) => (
          <Col
            xs={12}
            sm={6}
            md={4}
            key={idx}
            className="mb-3 d-flex align-items-center"
          >
            <span className="text-muted">{item.label}</span>
          </Col>
        ))}
      </Row>

      {items.length > previewCount && (
        <div className="mt-4 border-top pt-4">
          <Button
            variant="outline-secondary"
            onClick={() => {
              setSelectedGroup({ name: groupName, items });
              setShowModal(true);
            }}
          >
            Zobacz wszystkie {items.length}
          </Button>
        </div>
      )}
    </div>
  );

  return (
    <>
      <CustomCard withoutHeader width={12} shadow={false} className="mb-2 mt-2">
        <Card.Title className="h5 fw-bold">{title}</Card.Title>
        {description && <p className="text-muted mb-4">{description}</p>}

        {singleGroup
          ? (() => {
            const matched = groups
              .filter((item) => selectedIds?.includes(item.id))
              .map((item) => ({ ...item, label: item.name }));

            return matched.length ? renderItems(matched, title, false) : null;
          })()
          : groups.map((group) => {
            const matched = group.amenities
              .filter((item) => selectedIds?.includes(item.id))
              .map((item) => ({ ...item, label: item.name }));

            return matched.length ? renderItems(matched, group.name, true) : null;
          })}
      </CustomCard>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        fullscreen="sm-down"
      >
        <Modal.Header closeButton>
          <Modal.Title>{selectedGroup?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedGroup?.items.map((item, idx) => (
            <div
              key={idx}
              className="d-flex align-items-center py-2 border-bottom"
            >
              <span>{item.label}</span>
            </div>
          ))}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GroupedPreviewList;
